import { render, staticRenderFns } from "./ModifyMemo.vue?vue&type=template&id=48a5af9a&"
import script from "./ModifyMemo.vue?vue&type=script&lang=js&"
export * from "./ModifyMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports